<template>
    <header class="header">
        <a 
            :href="urlDashboard" 
            @click.prevent="acessarInicio"
            class="logo pt-2 pt-md-0"
        >
            <img 
                :src="this.$app.caminho_logomarca" 
                border="0" 
                width="95%" 
                :title="this.$app.nome" 
                v-cloak 
            />
        </a>
        <nav 
            class="navbar navbar-expand-lg" 
            role="navigation"
        >
            <a 
                href="#" 
                @click.prevent="alternarBarraLateral" 
                class="navbar-btn sidebar-toggle" 
                data-toggle="offcanvas" 
                role="button"
            >
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </a>
            <div class="navbar-right">
                <slot name="modalidade">
                    <component 
                        v-if="modalidade" 
                        :is="modalidade" 
                    >
                        <template v-if="$slots.botoes" #botoes>
                            <slot name="botoes" />
                        </template>
                        <template v-if="$slots.agenda" #agenda>
                            <slot name="agenda" />
                        </template>
                        <template v-if="$slots.aplicativos" #aplicativos>
                            <slot name="aplicativos" />
                        </template>
                        <template v-if="$slots.notificacoes" #notificacoes>
                            <slot name="notificacoes" />
                        </template>
                        <template v-if="$slots.botoes" #botoes>
                            <slot name="botoes" />
                        </template>
                    </component>
                </slot>
            </div>
        </nav>
    </header>
</template>
<script>
import { mostraMenu, escondeMenu } from '../../functions/menu'
import { acessaDashboard, pegaUrlDashboard } from '@/shared/common/functions/dashboard'
export default {
    data() {
        return {
            modalidade: null,
        };
    },
    computed: {
        urlDashboard() {
            return pegaUrlDashboard()
        },
    },
    components: {
        ERP: () => import('./ERP'),
        NFE: () => import('./NFE'),
    },
    async mounted() {
        let modalidade = this.$usuarioLogado.Empresa.modalidade
        if (!this.$options.components[modalidade]) {
            modalidade = 'ERP'
        }
        this.modalidade = modalidade
        if (this.$isMobile() || this.$route.meta.fullScreen) {
            escondeMenu()
        }
    },
    watch: {
        $route(to, from) {
            if (to.path != from.path) {
                if (this.$isMobile() || to.meta.fullScreen) {
                    escondeMenu()
                } else {
                    mostraMenu()
                }
            }
        }
    },
    methods: {
        alternarBarraLateral() {
            const leftSide = document.querySelector('.left-side')
            if (leftSide.classList.contains('collapse-left')) {
                mostraMenu()
            } else {
                escondeMenu()
            }
        },
        acessarInicio() {
            acessaDashboard(this.urlDashboard);
        },
    }
};
</script>
<style>
header.header > .dropdown {
    float: left;
}
header.header .dropdown-toggle:after {
    content: none;
}
header.header .navbar {
    position: relative;
    min-height: 50px;
    display: block;
    flex-wrap: unset;
    padding: 0;
}
header.header .navbar-nav {
    flex-direction: unset;
}
header.header .navbar-right {
    float: right;
}
header.header .navbar-nav .user-menu .dropdown-menu {
    padding: 0;
}
/* Celular: a linha do topo (menu à esquerda, itens à direita) nunca quebra. Com float,
   quando os itens da direita não cabiam ao lado do botão de menu eles caíam para baixo do
   fundo escuro, e os ícones brancos sumiam no fundo claro da página ("no mobile fica
   desconfigurado", 2026-09-13, visto num iPhone no formulário de recebimento). Flex sem
   quebra mantém tudo numa linha; o alinhamento pelo topo preserva a posição vertical que os
   floats já davam (o botão de aplicativos tem margem de 13px em cima). */
@media (max-width: 767.98px) {
    header.header .navbar {
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-start;
    }
    header.header .navbar .sidebar-toggle {
        float: none;
        flex: none;
    }
    header.header .navbar-right {
        float: none;
        margin-left: auto;
        min-width: 0;
    }
    header.header .navbar-right > .navbar-nav {
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-start;
        float: none;
    }
    header.header .navbar-right > .navbar-nav > li {
        float: none;
        flex: none;
    }
}
@media (max-width: 424px) {
    .navbar-nav-app a.nav-link {
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
}
</style>